import { SectionPersonnelAlarmCounter } from "./SectionPersonnelAlarmCounter";
export default SectionPersonnelAlarmCounter;
